import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'bootstrap';
import VueGoogleMaps from '@fawmi/vue-google-maps'


createApp(App)
  .use(router)
  .use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBw-Ld2uyp74D05cs6QOK3CVpnKcjxJ1e0",
    //key: "AIzaSyCVuGowOyeLh0p8CM7OrTXDCNO8PuftieA"
  }
})

.mount('#app')
